// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3zkbF","subheader":"ReorderModal_subheader__3r1tL","listWrap":"ReorderModal_listWrap__9cyq2"};